module.exports = __webpack_public_path__ + "img/card3.0404325a.jpg";